import { render, staticRenderFns } from "./FuSpeedDialItem.vue?vue&type=template&id=0c08e02c&"
import script from "./FuSpeedDialItem.vue?vue&type=script&lang=js&"
export * from "./FuSpeedDialItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports